///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.create = abcsetup.new_customer_matching.events.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.create = {

    categories: [],

    init: function () {
        // Pull in our categories
        abcsetup.new_customer_matching.events.create.categories = $('#category-list').val().toLowerCase().split('|');

        // Validate the input file
        $(document).on("change", "#app_models_new_customer_matching_import_item__import_location", function (e) {
            abcsetup.new_customer_matching.events.create.validateInputFile($(this));
        });

        // Set the min date for the review deadline
        $(document).on("change", "#app_models_new_customer_matching_event__event_end_date", function (e) {
            const min = moment($(this).val(), "YYYY-MM-DD").add(1, 'days');
            $('#app_models_new_customer_matching_event__cm_review_deadline').attr('min', min.format('YYYY-MM-DD'));
        });

        //boot common scripts
        abcsetup.new_customer_matching.events.common.init();
    },

    validateInputFile: function (fileInput) {
        let file = fileInput[0];
        let errors = [];

        if (file.files.length > 0) {
            const column_map = [
                'customer_item_number',
                'sap',
                'product_description',
                'upc',
                'ndc',
                'mfr_part_number',
                'brand_reference',
                'brand_required',
                'pkg_size',
                'pkg_uom',
                'current_vendor',
                'est_total_annual_pkgs',
                'category',
                'category_manager',
                'abc_item',
                'item_description',
                'vendor',
                'current_bid',
                'target_price',
                'bid_upc',
                'bid_pkg_size',
            ];

            abcsetup.blockUI(true);
            abcsetup.excel.readFile(file, function(data) {
                let rows = abcsetup.excel.toArray(data, column_map);

                for (i in rows) {

                    if (!abcsetup.new_customer_matching.events.create.validateSAP(rows[i].sap)) {
                        errors.push('Line ' + (parseInt(i, 10)+2) + ': SAP # must be 8 digits long, '+rows[i].length+' given.');
                    }

                    if (!abcsetup.new_customer_matching.events.create.validateCategory(rows[i].category)) {
                        errors.push('Line ' + (parseInt(i, 10)+2) + ': Category "'+rows[i].category+'" is invalid.');
                    }

                    if (!abcsetup.new_customer_matching.events.create.validateDescription(rows[i].product_description)) {
                        errors.push('Line ' + (parseInt(i, 10)+2) + ': Product Description cannot be blank.');
                    }

                }

                abcsetup.unblockUI();

                if (errors.length > 0) {
                    abcsetup.alerts.show('Import Errors', errors.join('<br>') + '<div class="mt-1"><strong class="block text-danger">File not uploaded.</strong></div>');
                    fileInput.val('');
                }

            }, true);
        }
    },

    /**
     * If the SAP # is defined, has a value, but is not 8 digits long, return false
     */
    validateSAP: function (sap) {
        if (sap.toString().length !== 0 && sap.toString().length !== 8 && isNaN(parseInt(sap, 10))) {
            return false;
        }

        return true;
    },

    /**
     * If the SAP # is defined, has a value, but is not 8 digits long, return false
     */
    validateCategory: function (category) {
        if ($.inArray(category.toLowerCase(), abcsetup.new_customer_matching.events.create.categories) === -1) {
            return false;
        }

        return true;
    },

    /**
     * If the SAP # is defined, has a value, but is not 8 digits long, return false
     */
    validateDescription: function (description) {
        if (description.length === 0) {
            return false;
        }

        return true;
    },
}
